import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { EBookerLocationType } from '@/data/bookerData'

export interface IBookerStoreState {
	booker: IBookerState
}

export interface IBookerStore {
	readonly state: IBookerStoreState
	setBooker(state: IBookerState): void
	setIsStartLocationMenuOpen(isOpen: boolean): void
	setIsEndLocationMenuOpen(isOpen: boolean): void
	setIsStartDateMenuOpen(isOpen: boolean): void
	setIsRenteonDateError(isError: boolean): void
	setDeliveryCosts(type: EBookerLocationType, cost: number | null): void
	setIsRedirectToReservationAfterDate(redirect: boolean): void
	getBooker(): IBookerState
	getIsStartLocationMenuOpen: ComputedRef<boolean>
	getIsEndLocationMenuOpen: ComputedRef<boolean>
	getIsStartDateMenuOpen: ComputedRef<boolean>
	getIsRenteonDateError: ComputedRef<boolean | null>
	getDeliveryCosts: ComputedRef<{
		start: number | null
		end: number | null
	}>
	getIsRedirectToReservationAfterDate: ComputedRef<boolean>
}

export const useBookerStore = defineStore('bookerStore', (): IBookerStore => {
	const _state = reactive<IBookerStoreState>({
		booker: {
			isStartLocationMenuOpen: false,
			isEndLocationMenuOpen: false,
			isStartDateMenuOpen: false,
			isRenteonDateError: false,
			deliveryCosts: {
				start: null,
				end: null,
			},
			isRedirectToReservationAfterDate: false,
		},
	})

	const setBooker = (state: IBookerState) => {
		_state.booker = state
	}

	const getBooker = () => {
		return _state.booker
	}

	const setIsStartLocationMenuOpen = (isOpen: boolean) => {
		_state.booker.isStartLocationMenuOpen = isOpen
	}

	const setIsEndLocationMenuOpen = (isOpen: boolean) => {
		_state.booker.isEndLocationMenuOpen = isOpen
	}

	const setIsStartDateMenuOpen = (isOpen: boolean) => {
		_state.booker.isStartDateMenuOpen = isOpen
	}

	const setIsRenteonDateError = (isError: boolean) => {
		_state.booker.isRenteonDateError = isError
	}

	const setDeliveryCosts = (type: EBookerLocationType, cost: number | null) => {
		_state.booker.deliveryCosts[type] = cost
	}

	const setIsRedirectToReservationAfterDate = (redirect: boolean) => {
		_state.booker.isRedirectToReservationAfterDate = redirect
	}

	const getIsRenteonDateError = computed(() => {
		return _state.booker.isRenteonDateError
	})

	const getIsStartLocationMenuOpen = computed(() => {
		return _state.booker.isStartLocationMenuOpen
	})

	const getIsEndLocationMenuOpen = computed(() => {
		return _state.booker.isEndLocationMenuOpen
	})

	const getIsStartDateMenuOpen = computed(() => {
		return _state.booker.isStartDateMenuOpen
	})

	const getDeliveryCosts = computed(() => {
		return _state.booker.deliveryCosts
	})

	const getIsRedirectToReservationAfterDate = computed(() => {
		return _state.booker.isRedirectToReservationAfterDate
	})

	return {
		state: _state,
		setBooker,
		setIsStartLocationMenuOpen,
		setIsEndLocationMenuOpen,
		setIsStartDateMenuOpen,
		setIsRenteonDateError,
		setDeliveryCosts,
		setIsRedirectToReservationAfterDate,
		getBooker,
		getIsStartLocationMenuOpen,
		getIsEndLocationMenuOpen,
		getIsStartDateMenuOpen,
		getIsRenteonDateError,
		getDeliveryCosts,
		getIsRedirectToReservationAfterDate,
	}
})
